import React from 'react';
import "../styles/App.scss";
//material ui
// import Button from '@mui/material/Button';
//components
import ProjectOptions from "./ProjectOptions";
import DarkToggle from "./DarkToggle";
import FontToggle from "./FontToggle";
import SoundToggle from "./SoundToggle";
import SoundButtonPlayer from './SoundButtonPlayer';
//navbar drop down components
import { originalProjectTitle, originalProjectsList} from "./projectData/OriginalProjects";
import {fanArtTitle, fanartData} from "./projectData/FanArt";
import {dtiysTitle, dtiysData} from "./projectData/Dtiys";

function Navbar({onFontChange,currFont}){
    return(
        <>
            <div className="App">
                <div className="App-navbar">
                    <SoundButtonPlayer href="/">
                        <div className="App-link">
                            <div className="App-logo"></div>
                        </div>
                    </SoundButtonPlayer>
                    <br/>
                    <div className="Navbar-content">
                        <div className="Navbar-icons">
                            {/*-- THE IMAGES WILL BE REPLACED WITH ACTUAL ICON COMPONENTS LATER: --*/}
                            {/* <img src="../../assets/icons/soundon-mode.png" alt="sound on"/> */}
                            <SoundToggle/>
                            {/* <img src="../../assets/icons/light-mode.png" alt="light mode"/> */}
                            <DarkToggle/>
                            {/* <img src="../../assets/icons/nodyslexia-mode.png" alt="no dyslexia"/> */}
                            <FontToggle onFontChange={onFontChange} currFont={currFont}/>
                        </div>
                        <div className="Navbar-top">
                            <div className="App-link">
                                <SoundButtonPlayer 
                                    className="App-buttons" 
                                    href="/"
                                >
                                        Home
                                </SoundButtonPlayer>
                            </div>
                            <SoundButtonPlayer>
                                <ProjectOptions
                                    projectTitle={originalProjectTitle}
                                    projectData={originalProjectsList}
                                />
                            </SoundButtonPlayer>
                            <SoundButtonPlayer>
                                <ProjectOptions
                                    projectTitle={fanArtTitle}
                                    projectData={fanartData}
                                />
                            </SoundButtonPlayer>
                            <SoundButtonPlayer>
                                <ProjectOptions
                                    projectTitle={dtiysTitle}
                                    projectData={dtiysData}
                                />
                            </SoundButtonPlayer>
                            
                        </div>
                        <br/>
                        <div className="Navbar-bottom">
                            <div className="App-link">
                                <SoundButtonPlayer className="App-buttons" href="/pages/About">
                                    About Me
                                </SoundButtonPlayer>
                            </div>
                            <div className="App-link">
                                <SoundButtonPlayer className="App-buttons" href="/pages/CommissionMe">
                                    Commisison Me
                                </SoundButtonPlayer>
                            </div>
                            <div className="App-link">
                                <SoundButtonPlayer className="App-buttons" href="/pages/CV">
                                    My CV
                                </SoundButtonPlayer>
                            </div>
                            <div className="App-link">
                                <SoundButtonPlayer className="App-buttons" href="/pages/MyLinks">
                                    Links
                                </SoundButtonPlayer>
                            </div>
                            <div className="App-link">
                                <SoundButtonPlayer className="App-buttons" href="/pages/Contact">
                                    Contact
                                </SoundButtonPlayer>
                            </div>
                        </div>
                        <br/>
                    </div>

                </div>
            </div>
        </>
    );
}

export default Navbar;